/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'attachment': {
    width: 512,
    height: 512,
    viewBox: '0 0 51.619 51.619',
    data: '<path pid="0" d="M50.14 19.206a.999.999 0 0 0-1.414 0L21.432 46.5a10.617 10.617 0 0 1-7.563 3.119c-2.867 0-5.553-1.107-7.564-3.119s-3.119-4.697-3.119-7.564c0-2.866 1.107-5.552 3.119-7.563L33.598 4.078c2.897-2.896 7.445-2.719 10.579.413 3.133 3.133 3.311 7.682.414 10.579l-25.64 25.641a3.685 3.685 0 0 1-5.203 0 3.684 3.684 0 0 1 0-5.203l17.369-17.369a.999.999 0 1 0-1.414-1.414L12.334 34.093a5.685 5.685 0 0 0 0 8.031 5.685 5.685 0 0 0 8.031 0l25.641-25.641c3.703-3.704 3.525-9.468-.414-13.407-3.938-3.938-9.703-4.117-13.407-.413L4.89 29.958c-2.39 2.389-3.705 5.577-3.705 8.978s1.315 6.59 3.705 8.979c2.389 2.39 5.577 3.705 8.979 3.705 3.4 0 6.589-1.315 8.978-3.705L50.14 20.62a.999.999 0 0 0 0-1.414z" _fill="#FFF"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/attachment.js